module.exports = __webpack_public_path__ + "img/fail.6619e11e.png";